var React = require('react');

function ExternalLinkInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.7559 3.24394V1.25557C13.7559 0.142577 15.1064 -0.42017 15.8943 0.367676L21.6342 6.1077C22.1219 6.59542 22.1219 7.38327 21.6342 7.87098L15.8943 13.611C15.1064 14.3989 13.7559 13.8486 13.7559 12.7356V10.6222C7.5032 10.6222 3.12633 12.6231 0 17C1.25053 10.7472 5.00213 4.49449 13.7559 3.24394Z","fill":"#349FCD"}));
}

ExternalLinkInline.defaultProps = {"width":"22","height":"17","viewBox":"0 0 22 17","fill":"none"};

module.exports = ExternalLinkInline;

ExternalLinkInline.default = ExternalLinkInline;
